import { render } from "./contacts-model.vue?vue&type=template&id=882324ee"
import script from "./contacts-model.vue?vue&type=script&lang=js"
export * from "./contacts-model.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__